export default "__VITE_ASSET__P$abOV$r__"